import { render, staticRenderFns } from "./PaginaEstaticaForm.vue?vue&type=template&id=a474ac1a&"
import script from "./PaginaEstaticaForm.vue?vue&type=script&lang=js&"
export * from "./PaginaEstaticaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports